
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.516 16.125V5.613H.246v10.512h3.27zM1.898 4.172c.493 0 .95-.176 1.336-.563.352-.351.563-.808.563-1.336 0-.492-.211-.949-.563-1.336-.386-.35-.843-.562-1.336-.562-.527 0-.984.21-1.335.563A1.836 1.836 0 000 2.272c0 .528.176.985.563 1.336.351.387.808.563 1.335.563zM15.75 16.125v-5.766c0-1.617-.246-2.812-.703-3.586-.633-.949-1.688-1.441-3.2-1.441-.773 0-1.406.211-1.968.563-.527.316-.914.703-1.125 1.16h-.035V5.613h-3.13v10.512h3.235v-5.203c0-.809.106-1.442.352-1.863.281-.563.808-.844 1.582-.844.738 0 1.23.316 1.512.95.14.386.21.983.21 1.827v5.133h3.27z"}})])
          )
        }
      }
    